module.exports = __webpack_public_path__ + "static/media/pf_item_23.13113fc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pf_item_23.jpg
// module id = 197
// module chunks = 0